import { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Heading,
  Menu,
  Button,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Center,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Masonry } from "masonic";
import PuffLoader from "react-spinners/PuffLoader";
import LinkedInPost from "components/tweets/masonry/linkedinPost";
import { formatTweetFromPost } from "../../utils/linkedinUtils";
import { CustomMenuButton, CustomMenuItem } from "components/custom-menu"
import { textStyle } from "theme/names";

export function MostResults({ stats = [], isLoading: propsIsLoading = false }) {
  const [data, setData] = useState<any>();
  const [filteredData, setFilteredData] = useState<any>();
  const [type, setType] = useState<string>("Engagement");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const compare = (a, b) => {
    const pair = {
      Engagement: "totalEngagement",
      Views: "numViews",
    };
    if (a[pair[type]] < b[pair[type]]) {
      return 1;
    }
    if (a[pair[type]] > b[pair[type]]) {
      return -1;
    }
    return 0;
  };

  const performFiltering = () => {
    const copyOfData = [...data];
    const sortedData = copyOfData.filter(x => x.text).sort(compare);
    // setFilteredData(sortedData.slice(0, 3));
    setFilteredData(sortedData.map(x => formatTweetFromPost(x)).slice(0, 3));

  };

  // executed on first load and on timeframe change
  useEffect(() => {
    if (data) {
      performFiltering();
    }
  }, [data]);

  // filter on type change
  useEffect(() => {
    if (data) {
      setIsLoading(true);
      performFiltering();
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    }
  }, [type]);

  useEffect(() => {
    if (stats && stats.length > 0) {
      setData([...stats]);
    } else {
      setData([]);
    }
  }, [stats]);

  const loading = isLoading || propsIsLoading;

  return (
    <Box>
      <Flex
        alignItems="center"
        wrap="wrap"
        justifyContent={{ base: "center", md: "start" }}
      >
        <Heading fontSize={"xl"}>Posts that generated the most</Heading>
        <Menu variant="secondary">
          <MenuButton
            as={Button}
            // size="sm"
            variant="secondary"
            rightIcon={<ChevronDownIcon />}
            marginX="3"
            mt={{ base: "4", md: "0" }}
          >
            {type}
          </MenuButton>
          <MenuList maxH="215px">
            {["Engagement", "Views"].map((x) => (
              <MenuItem
                key={x}
                onClick={async (e) => {
                  setType(x);
                }}
              >
                {x}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        {type === "Followers" && (
          <Text
            textStyle={textStyle["body.medium.light"]}
            as="i"
            color="gray"
            fontSize="xs"
            mt={{ base: "4", md: "0" }}
          >
            based on profile visits
          </Text>
        )}
      </Flex>
      {loading && (
        <Center pt={10} h="400px">
          <PuffLoader
            color={"#0A66C2"} 
            loading={loading}
            cssOverride={{
              display: "block",
              margin: "0 auto",
              borderColor: "red",
            }}
            size={50}
          />
        </Center>
      )}
      {!loading &&
        (filteredData && filteredData?.length > 0 ? (
          <Box mt="12" pl={{ base: "0", md: "10" }}>
            <Masonry
              key={filteredData.length}
              items={filteredData}
              columnWidth={260}
              columnGutter={20}
              // @ts-ignore
              render={(tweet) => <LinkedInPost tweet={tweet} />}
            />
          </Box>
        ) : (
          <Text
            textStyle={textStyle["body.medium.light"]}
            mt="8"
            textAlign="center"
          >
            No posts found. Please try a different time frame.
          </Text>
        ))}
    </Box>
  );
}
